/**
* @summary - Component that Provides Work Group Creation Page
* @author Aro J
* @since 2024-06-28
*/
import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import CreateDocumentSerialNumber from '../../components/documnetserialnumbercomponents/CreateDocumentSerialNumber'

function DocumentSerialNumberRegister({renderPageContent}) {
    return (
        <>
                        <CreateDocumentSerialNumber renderPageContent={renderPageContent}/>
                       
                       
        </>
    )
}

export default DocumentSerialNumberRegister;